import { useEffect } from 'react';

import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { initializeFirebaseWeb } from '@/adapters/pushNotification/firebaseInitialization.web';

const useFirebaseWebInitialization = () => {
  useEffect(() => {
    const initFirebase = async () => {
      const hasRequiredApis = 'serviceWorker' in navigator && 'Notification' in window;
      if (!hasRequiredApis) {
        sentryLogger.captureMessage(
          'Firebase Cloud Messaging not supported in this browser',
          'info',
        );

        return;
      }

      const { isSupported } = await import('firebase/messaging');
      const supported = await isSupported();
      if (!supported) {
        sentryLogger.captureMessage(
          'Firebase Cloud Messaging not supported in this browser',
          'info',
        );

        return;
      }

      try {
        initializeFirebaseWeb();

        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        sentryLogger.addBreadcrumb('Service Worker registered for FCM', {
          scope: registration.scope,
        });
      } catch (error) {
        sentryLogger.captureException(error, {
          tags: { context: 'firebase_web_initialization' },
        });
      }
    };

    void initFirebase();
  }, []);
};

export { useFirebaseWebInitialization };
